import { Component, ChangeDetectionStrategy } from '@angular/core';
import { PartnersService } from '../services/partners.service';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-container',
    templateUrl: './container.component.html',
    styleUrls: ['./container.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [PartnersService],
    imports: [RouterOutlet],
})
export class ContainerComponent {}
